import * as React from "react"
export const ToolbarScale = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
        height={20}
         viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <g >
      <path
        fill="#6C757D"
        d="M17.5 10.834c-.293 0-.572.06-.833.153V10a3.337 3.337 0 0 0-3.334-3.333H6.667A3.337 3.337 0 0 0 3.333 10v.987a2.473 2.473 0 0 0-.833-.153 2.503 2.503 0 0 0-2.5 2.5v1.25c0 1.297.662 2.441 1.667 3.115v1.468a.834.834 0 0 0 1.666 0v-.876c.139.016.274.043.417.043h12.5c.142 0 .278-.027.417-.043v.876a.834.834 0 0 0 1.666 0V17.7A3.748 3.748 0 0 0 20 14.584v-1.25c0-1.379-1.122-2.5-2.5-2.5ZM5 10c0-.919.747-1.666 1.667-1.666h6.666C14.253 8.334 15 9.08 15 10v3.334H5V10Zm13.333 4.584a2.086 2.086 0 0 1-2.083 2.083H3.75a2.086 2.086 0 0 1-2.083-2.083v-1.25c0-.46.374-.834.833-.834.46 0 .833.375.833.834v.833c0 .46.374.833.834.833h11.666c.46 0 .834-.373.834-.833v-.833c0-.46.374-.834.833-.834.46 0 .833.375.833.834v1.25ZM.435 4.378C.178 4.153 0 3.753 0 3.334c0-.42.178-.82.49-1.099L2.305.268A.834.834 0 0 1 3.528 1.4L2.51 2.5h14.982l-1.02-1.1A.833.833 0 1 1 17.695.268l1.87 2.022c.257.225.435.625.435 1.044 0 .419-.178.819-.49 1.098L17.695 6.4a.83.83 0 0 1-1.178.045.834.834 0 0 1-.045-1.177l1.018-1.1H2.508l1.02 1.1A.833.833 0 1 1 2.305 6.4L.435 4.378Z"
      />
    </g>

  </svg>
)
